import { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import SnowballCTA from '../Snowball/SnowballCTA'
import styles from './TransactionSuggestion.module.css'
import {
    formatCurrency,
    scrollToTop
} from '../../utilities/general-utils'
import { IconAngleRightBold, IconCloseBold, IconStar } from '../../assets/icons'
import TransactionCreate from '../../pages/TransactionCreate'

const TransactionSuggestion = ({ item, onEdit }) => {
    const itemRef = useRef(null)
    const [updatedItem, setUpdatedItem] = useState(item)
    const [isExpanded, setIsExpanded] = useState(false)

    const handleItemChange = (transaction) => {
        setUpdatedItem({
            ...updatedItem,
            ...transaction,
        })
    }

    const handleTransactionCreated = (accessToken, response) => {
        if (response.error) return

        setUpdatedItem({
            ...updatedItem,
            createdTransactions: [
                ...updatedItem.createdTransactions,
                {
                    id: response.data.insertId,
                    title: updatedItem.title
                }
            ]
        })
        scrollToTop(itemRef.current, -50)
    }

    const handleEditClick = () => {
        isExpanded ? onEdit(isExpanded, itemRef.current) : onEdit(!isExpanded)
        setIsExpanded(!isExpanded)
    }

    return (
        <div
            ref={itemRef}
            className={`${styles.item} ${styles.itemDetail} ${isExpanded ? styles.expanded : ''}`}
        >
            {updatedItem.category === 'Debt Payment' && isExpanded && <SnowballCTA />}

            <HeaderInfo
                item={updatedItem}
                isExpanded={isExpanded}
                onEditClick={handleEditClick}
            />

            {isExpanded && (
                <TransactionCreate
                    transactionItem={item}
                    redirectOnCreate={false}
                    onCreate={handleTransactionCreated}
                    onTransactionChange={handleItemChange}
                />
            )}
        </div>
    )
}

const HeaderInfo = ({ item, isExpanded, onEditClick }) => {
    const [showCreatedTransactions, setShowCreatedTransactions] = useState(false)
    const isNegativeTransaction = item.amount < 0

    return (
        <div className={styles.itemHeader}>
            {item.createdTransactions.length > 0 && (
                <CreatedTransactions
                    createdTransactions={item.createdTransactions}
                    transactionsVisible={showCreatedTransactions}
                    onIconClick={setShowCreatedTransactions}
                />
            )}

            <div className={styles.itemHeaderIconWrap}><IconStar /></div>

            <h4 className={styles.itemHeaderTitle}>
                {item.title}
            </h4>

            <h5 className={styles.itemHeaderCategory}>
                {item.category}
            </h5>

            <div className={`${styles.itemHeaderAmount} ${isNegativeTransaction ? styles.negativeAmount : ''}`}>
                {formatCurrency(item.amount)}
            </div>

            <div className={styles.itemHeaderFrequency}>
                {item.recurringType}
            </div>

            <button
                className={`${styles.itemHeaderToggle} button button-small button-gray`}
                onClick={onEditClick}
            >
                {isExpanded ? 'Hide Details' : 'Edit & Save'}
            </button>
        </div>
    )
}

const CreatedTransactions = ({ createdTransactions, transactionsVisible, onIconClick }) => {
    return (
        <div className={`${styles.createdTransactionsWrap} ${transactionsVisible ? styles.transactionsVisible : ''}`}>
            <div className={styles.createdTransactions}>
                <div onClick={() => onIconClick(!transactionsVisible)} className={styles.createdTransactionsIconWrap}>
                    {createdTransactions.length}
                </div>

                {transactionsVisible && (
                    <div className={styles.createdTransactionsBody}>
                        <IconCloseBold onClick={() => onIconClick(false)} fill="#fff" wrapperClass={styles.createdTransactionsClose} />
                        <p className={styles.createdTransactionsText}>
                            You've used this template<br /> to create {createdTransactions.length} transaction{createdTransactions.length > 1 ? 's' : ''}
                        </p>
                        <ul className={styles.createdTransactionsList}>
                            {createdTransactions.map((transaction) => (
                                <li key={transaction.id}>
                                    <Link
                                        className='text-link'
                                        key={transaction.id}
                                        to={`/transaction/${transaction.id}`}
                                    >
                                        {transaction.title} <IconAngleRightBold fill="#fff" />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TransactionSuggestion